module.exports = __webpack_public_path__ + "img/105.c7a765ce.png";